import ApprovalSettingsList from "../../containers/approval-settings/WorkflowList";
import WorkflowDetails from "../../containers/approval-settings/WorkflowDetails";

const ApprovalSettings = {
  ApprovalSettingsList,
  WorkflowDetails
};

export { 
  ApprovalSettings as default, 
  ApprovalSettingsList,
  WorkflowDetails
};
